/**
 * Shared FMSLogger instance for all OTA Management components.
 *
 * Usage:
 *   import { otaLogger } from "../../logger";          // from a component
 *   const log = otaLogger.byPrefix("MyComponent");
 *   log.error("Something failed", err);
 */
import { FMSLogger } from "FMSLogger";

export const otaLogger = FMSLogger;
